<template>
    <div>
        <image-slide v-if="slide.type == 'image' && (dataStore.viewActive.normal || dataStore.viewActive.heatmap)" :slide="slide" :addopinion="addopinion" :slides="project.items" :getPinImage="getPinImage" :index="index" :slug="project.slug" :project="project" :componentKey="componentKey" />
        <map-slide v-if="slide.type == 'map' && (dataStore.viewActive.normal || dataStore.viewActive.heatmap)" :ref="`gmap-${slide.id}`" :slide="slide" :addopinion="addopinion" :index="index" :getPinImage="getPinImage" :project="project" :slug="project.slug" />
        <question-slide v-if="(slide.type == 'map' || slide.type == 'image') && !addopinion && dataStore.viewActive.listing" :slide="slide" :index="index" :addopinion="addopinion" :project="project" :parentslug="project.slug" />
    </div>
</template>

<script>

import dataStore from "../../store"

import { applyFiltersRequest } from "./../../functions"

import { createHeatMapsImages } from "./../../image-functions"

import ImageSlide from "./../item-components/ImageSlide"

import MapSlide from "./../item-components/MapSlide"

import QuestionSlide from "./../item-components/QuestionSlide"

export default {

    data() {

        return {
            dataStore,
            clicked : false
        }

    },

    props: {

        slide : Object,

        project : Object,

        getPinImage : Function,

        addopinion: Boolean,

        componentKey : Number,

        index : Number,

        type: {
            type: [String],
            default: null
        }

    },

    mounted() {

        if( window.location.pathname.includes('preview-project-report') && ! this.clicked ) {

            this.$nextTick(() => {
                this.init()
            })
            
        }
    },

    components : {

        ImageSlide,

        MapSlide,

        QuestionSlide

    },

    methods: {

        init : async function () {

            const slug = window.location.pathname

            const projectParts = slug.split('preview-project-report')

            const lastPart = projectParts[1].replace(/^\/|\/$/g, '').replace( this.project.slug, '' )

            const parts = lastPart.replace(/^\/|\/$/g, '').split('/')

            let id = parts[1]

            let index = parts[2]

            if ( (  id === undefined || id === null || ! this.isNumeric( id ) ) || ( index === undefined || index === null || ! this.isNumeric( index ) ) ) return

            id = Number( id )

            index = Number( index )

            const heatmaps = ['goodbad', 'good', 'bad']

            if( this.type ) {

                this.dataStore.showOptionMenu = true;

                if( this.dataStore.slickNavigation ) {

                    this.dataStore.slickNavigation.goTo( index )
                }

                // need to be here as varible - need to move to slide before getting active
                const isType = document.querySelector('.slider-for .slick-current.slick-active .item-slide')

                if( heatmaps.includes( this.type )) {

                    if( this.type === 'goodbad' ) {
                        this.dataStore.selectedFilters = [ { value : 'good', type : 'good_bad' }, { value : 'bad', type : 'good_bad' } ]
                    } 
                    
                    else {
                        this.dataStore.selectedFilters = [ { value : this.type, type : 'good_bad' } ]
                    }

                    if( isType.classList.contains('image-type') ) {

                        applyFiltersRequest()
                        
                        .then(response => {

                            if( response.data === null ) return

                                const imageSlide = document.querySelectorAll('.slider-for .slick-current.slick-active .item-slide .image-type-slide')

                                const height = document.querySelector('.slider-for .slick-current.slick-active .item-slide .image-type-slide').height

                                if( imageSlide.length && height > 0 ) {

                                    createHeatMapsImages( this.dataStore.currentSlide , response.data )

                                    document.querySelectorAll('.slider-for .slick-slide .pin').forEach( e => e.remove() )

                                    this.clicked = true
                                }


                        })

                        .catch(error => {
                            console.log(error)
                        })

                    }

                }

                if( this.type === 'hero' ) {

                    document.querySelectorAll('.slider-for .slick-current.slick-active .pin').forEach( e => e.remove() )

                    this.dataStore.collectedAnswers = []

                    this.dataStore.showPolygon = false

                }

            }

        },

        isNumeric: function(str) {

            if ( typeof str != 'string' ) return false

            return ! isNaN( str ) && ! isNaN( parseFloat( str ) )

        }
    }

}

</script>

